import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-slate-900 py-16 md:py-24" data-id="element-132">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-135">
            La Realidad de Vivir en USA
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-136">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-slate-800 p-8 rounded-2xl border border-slate-700 shadow-xl" data-id="element-137">
            <div className="flex items-start gap-4 mb-4" data-id="element-138">
              <AlertCircle className="w-8 h-8 text-red-400 flex-shrink-0" data-id="element-139" />
              <p className="text-slate-300 text-lg" data-id="element-140">
                Vivir en USA es caro y el dinero parece desaparecer antes de que
                termine el mes. Quieres ayudar en casa, pero entre los niños, la
                falta de permisos de trabajo o el inglés, te sientes limitada.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-slate-800 p-8 rounded-2xl border border-slate-700 shadow-xl" data-id="element-141">
            <div className="flex items-start gap-4 mb-4" data-id="element-142">
              <AlertCircle className="w-8 h-8 text-red-400 flex-shrink-0" data-id="element-143" />
              <p className="text-slate-300 text-lg" data-id="element-144">
                Has intentado de todo: encuestas que pagan centavos,
                multiniveles donde tienes que perseguir a tus amigos, o ventas
                por catálogo que te obligan a invertir miles de dólares en
                inventario que nadie quiere. El resultado siempre es el mismo:
                más estrés y menos dinero en la cartera.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}